import { UserProfileDto } from '@buck-e-icp/interfaces';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AUTH_FEATURE_NAME = '[Auth]';
export const AuthActions = createActionGroup({
    source: AUTH_FEATURE_NAME,
    events: {
        'Start auto login': emptyProps(),
        'Login success': props<{
            availableProfiles: UserProfileDto[];
            activeProfile: UserProfileDto;
            redirect: boolean;
        }>(),
        'Login failed': props<{
            error: string;
        }>(),
        Logout: props<{
            redirectUri: string;
        }>(),
        'Logout success': props<{
            redirect: boolean;
        }>(),
        'Logout failed': props<{
            error: string;
        }>(),
        'Select profile': props<{
            profiles: UserProfileDto[];
            email?: string;
        }>(),
    },
});
